<template>
  <div v-if="!editedItem && !loading" style="text-align:center;color:orange;padding:20px;">
    <b>
      <h2>
      Debe estar logueado para realizar la solicitud / You must be logged in to submit the request
      </h2>
    </b>
  </div>
  <div style="color: red;" v-else-if="editedItem" class="abama-request">
    <v-row no-gutters>
      <v-col
        cols="12"
        sm="12"
      >
    <v-select
      v-model="editedItem.folder"
      :items="folders"
      label="Propiedad"
      outlined
      hideDetails
    />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        style="text-align: center;padding-top:20px;"
      >
    <v-date-picker
      v-model="editedItem.rangeDates"
      range
      :min="minDate"
      locale="es-es"
      :color="BGColor"
    />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        style="padding: 20px;text-align:center;;"
      >
    <small style="text-style: italic;color: orange;">
          <b>Se puede reservar 3 meses después de la fecha actual / Can be booked 3 months after the current date</b>
    </small>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        style="padding: 20px 0;"
      >
    <v-textarea
      v-model="editedItem.notes"
      label="Notes"
      counter
      maxlength="120"
      full-width
      single-line
      hideDetails
      outlined
    />
      </v-col>
      <v-col
        cols="12"
        sm="12"
        style="padding-bottom: 20px;"
      >
    <v-btn
      @click="handleSend"
      :disabled="loading"
      :color="BGColor"
      block
          dark
    >
      {{ $t('common.send', locale) }}
    </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import axios from 'axios'
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      content: {
        type: Object,
        required: true,
        default: null
      },
      columnType: {
        type: String,
        required: false,
        default: 'xs12'
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      },
    },
    data: () => ({
      editedItem: null,
      user: null,
      folders: null,
      loading: false,
      rules: {
        length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
      },
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'BGColor', 'authData']),
      minDate () {
        let date = new Date()
        date = date.setMonth(date.getMonth() + 3)
        return new Date(date).toISOString().split('T').shift()
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop() {
        return !utils.isMobile()
      },
      width () {
        if (this.isSimulation) return `${utils.getWidthPaddingDiff(375, this.data.Padding)}px`
        if (this.isDesktop) return `${utils.getWidthPaddingDiff(this.sizeW, this.data.Padding)}px !important`
        return '100% !important'
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      }
    },
    watch: {
      authData () {
        this.handleGetData()
      },
    },
    mounted () {
      this.loading = true
      this.handleGetData()
    },
    methods: {
      async handleGetData () {
        this.loading = true
        this.editedItem = null
        const dfileToken = this.$session.get('dfilesResponse') || this.dfileResp
        try {
          this.user = await new Promise((resolve, reject) => axios.get(`${process.env.VUE_APP_API_URL_DFILES}/external/customers/info/?token=${dfileToken}`)
            .then(response => {
              resolve(response.data)
            })
            .catch((error) => {
              reject(error)
            }))
          if (!this.user || !this.user.ID) return

          this.folders = await new Promise((resolve, reject) => axios.get(`${process.env.VUE_APP_API_URL_DFILES}/external/customers/folders/?token=${dfileToken}&item_per_page=1000start_index=0&search_value=`)
            .then(response => {
              if (!response.data || !response.data.data) return resolve([])
              resolve(response.data.data.map(item => {
                return item.Name.es || item.Name.en || item.Name.de
              }).filter(x => x.length <= 10))
            })
            .catch((error) => {
              reject(error)
            }))
          if (this.folders.length > 0) this.editedItem = {
            rangeDates: [],
            clientID: this.user.ID,
            folder: this.folders[0]
          }
        } catch (error) {
          console.log(error)
        }
        this.loading = false
      },
      handleSend () {
        this.loading = true
        if (!this.editedItem.rangeDates || this.editedItem.rangeDates.length !== 2) {
          alert('Fecha de la reserva requerida')
          return
        }

        const dfileToken = this.$session.get('dfilesResponse') || this.dfileResp
        axios.post(`${process.env.VUE_APP_API_URL_DFILES}/external/customers/abama-request-reservation/?token=${dfileToken}`, this.editedItem)
          .then(response => {
            alert('Completado')
            this.loading = false
          })
          .catch( (error) => {
            console.log(error)
            alert('Error')
            this.loading = false
          })
      },
    }
  }
</script>
<style>
  .abama-request .v-picker__title {
    display: none;
  }
  .ql-editor p {
    font-size: var(--FontSizeContent);
  }
  .result-html .ql-toolbar.ql-snow {
    height: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .result-html .ql-container.ql-snow {
    border: 0px !important;
  }
  .result-html .ql-editor {
    min-height: 0px !important;
  }   
</style>
